import { Component, ContentChild, Input } from '@angular/core';

import { BadgeComponent } from '../badge/badge.component';
import { IconHelpComponent } from '../icon-help/icon-help.component';
import { IconComponent } from '../icon/icon.component';
import { SparksAnimationComponent } from '../sparks-animation/sparks-animation.component';
import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-heading',
  styleUrls: ['./heading.component.less'],
  templateUrl: './heading.component.html',
  host: {
    '[class.has-icon]': 'icon || sparksAnimation',
    '[class.truncated]': 'truncated',
    '[class.has-text-color-red]': 'hasTextColorRed',
    '[class.text-color-light]': 'hasTextColorLight',
    '[class.correct-line-height]': 'hasCorrectLineHeight',
    '[class]': 'variant',
    '[class.text-wrap]': 'textWrap',
  },
  imports: [],
})
export class HeadingComponent {
  public static readonly VARIANTS: Variants = [
    'heading',
    [
      'heading',
      'subheading',
      'large',
      'large-x',
      'large-x-dialog-header',
      'large-xx',
      'large-xxx',
      'uppercased',
      'block',
      'space-bottom',
      'icon-right',
      'text-color',
      'text-color-light',
      'small',
      'light',
      'normal',
      'dark',
      'align-center',
      'size-default',
      'lighter',
      'disabled',
      'semi-bold',
    ],
  ];
  @ComponentVariant(HeadingComponent.VARIANTS)
  @Input()
  public variant: string;

  @ContentChild(SparksAnimationComponent)
  public sparksAnimation: SparksAnimationComponent;
  @ContentChild(IconComponent)
  public icon: IconComponent;
  @ContentChild(IconHelpComponent, { static: false })
  public iconHelp: IconHelpComponent;
  @ContentChild(BadgeComponent, { static: false })
  public badge: BadgeComponent;

  @Input() public showIcon: boolean = true;
  @Input() public truncated: boolean = false;
  @Input() public hasCorrectLineHeight: boolean = false;
  @Input() public hasTextColorLight: boolean = false;
  @Input() public hasTextColorRed: boolean = false;
  @Input() public textWrap: boolean = false;
}
